module.exports = __webpack_public_path__ + "static/ia-b7c18c0e8bc60397d94b0e064f19388d.png";